import * as React from 'react'

import { Site } from '@envato/foundation-types'

import { config } from '../../../../common/config'
import { hasFeature } from '../../../../common/utils/features'
import NextGenImageWrapper from '../../nextGenImageWrapper'
import SeoHeadings from '../../seoHeadings/seoHeadings'
import { ICommonLocation } from '../../../../common/utils/location/types'
import { IExperimentsState } from '../../../../common/reducers/experiments'

import * as styles from './searchHeaderBlock.module.css'
import * as seoHeadingsSmallStyles from '../../../components/seoHeadings/themes/homepage.newdesign.small.module.css'
import * as seoHeadingsSmallCenteredStyles from '../../../components/seoHeadings/themes/homepage.newdesign.small.centred.module.css'
import * as classnames from 'classnames'

interface IProps {
  header?: string
  subheading?: string
  currentSite: Site
  location: ICommonLocation
  experiments: IExperimentsState
}

const getDesktopImageUrl = (
  currentSite: string,
  hasNewHomeHeaderImages: boolean
) => {
  const filename = hasNewHomeHeaderImages
    ? 'search-header-new'
    : 'search-header'
  return `${config.assets.PUBLIC_PATH}/images/home-page/new-design/${currentSite}/${filename}-1600749088571.webp`
}

const SearchHeaderBlock: React.SFC<IProps> = ({
  children,
  currentSite,
  header,
  subheading,
  location,
  experiments
}) => {
  const hasNewHomeHeaderImages = hasFeature(
    'newHomeHeaderImages',
    currentSite,
    location,
    experiments
  )

  const hasHomeHeaderCopyOnly = hasFeature(
    'homeHeaderCopyOnly',
    currentSite,
    location,
    experiments
  )

  const imageStyle =
    currentSite === Site.audiojungle && !hasNewHomeHeaderImages
      ? styles.imageWrapperAudio
      : styles.imageWrapper

  let headerStyle = seoHeadingsSmallStyles
  const seoHeaderClass = styles.seoHeader

  if (hasHomeHeaderCopyOnly) {
    headerStyle = seoHeadingsSmallCenteredStyles
  }

  if ([Site.codecanyon, Site.graphicriver].includes(currentSite)) {
    subheading = ''
  }

  return (
    <section className={styles.root}>
      <div
        className={classnames(styles.wrapper, {
          [styles.wrapperImageless]: hasHomeHeaderCopyOnly
        })}
      >
        <div className={styles.autosuggestWrapper}>
          <div className={seoHeaderClass}>
            <SeoHeadings
              TagName="h1"
              heading={
                header || 'Discover thousands of web themes and templates'
              }
              subHeading={subheading || ''}
              styles={headerStyle}
            />
          </div>
          <div className={styles.childrenContainer}>{children}</div>
        </div>
        {!hasHomeHeaderCopyOnly && (
          <div className={imageStyle}>
            <NextGenImageWrapper>
              <img
                src={getDesktopImageUrl(currentSite, hasNewHomeHeaderImages)}
                alt={`${currentSite} hero image`}
                className={styles.image}
              />
            </NextGenImageWrapper>
          </div>
        )}
      </div>
    </section>
  )
}

export default SearchHeaderBlock
